<template>
    <ShadowBoxContainer>
        <ListContainer
            :image="require(`@/assets/img/icon_listmytools_step2_information.svg`)"
            imageLabel="General Information"
            heading="Add relevant tags to help people get better search results."
            :step="5"
        >

            <div class="ph3 ph4-ns">
                <AddTags v-model="tags"/>
                <Info title="What makes a good tag?">
                    <ul>
                        <li>Nicknames, if applicable (e.g. Sawzall, Whipper Snipper, Trolley)</li>
                        <li>Size (e.g. 18-Volt, 22.7 L , 150 PSI, 18 Gauge)</li>
                        <li>Additional details that are not including in the listing title (e.g. Hex Grip, Self-Cleaning, Magnetic Guide)</li>
                    </ul>
                </Info>
            </div>
        </ListContainer>
        <!-- buttons -->
        <template slot="actionBar">
            <NavigationButtons back="Back" :forward="forwardText" @backClick="$router.push('/description')" @forwardClick="next" />
        </template>

    </ShadowBoxContainer>
</template>

<script>
import NavigationButtons from '@/components/global/NavigationButtons.vue';
import ShadowBoxContainer from '@/components/layout/ShadowBoxContainer.vue';
import ListContainer from '@/components/list/shared/ListContainer.vue';
import Info from '@/components/list/shared/Info.vue';
import AddTags from '@/components/list/tags/AddTags.vue';
import { mapMutations } from 'vuex';

export default {
    components: {
        NavigationButtons,
        ShadowBoxContainer,
        ListContainer,
        Info,
        AddTags
    },
    data() {
        return {
            tags: []
        };
    },
    computed: {
        forwardText() {
            return this.tags.length > 0 ? 'Next' : 'Skip';
        }
    },
    methods: {
        ...mapMutations('newListing', ['setTags']),
        next() {
            this.setTags(this.tags.map(x => x.text));
            this.$router.push('/owner-delivery');
        }
    }
};
</script>
